import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import { formatDate } from "../../Helper/Helper";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

function StackedHomeNews() {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasData, setHasData] = useState(false); // Initialize as false

  useEffect(() => {
    getNewsData();
  }, []);

  const getNewsData = async () => {
    try {
      const response = await SendPostRequest("news/list");

      if (!response?.data || response.data.length === 0) {
        setHasData(false);
        setLoading(false);
        return;
      }

      const mappedItems = response.data.map((item) => ({
        id: item.id,
        title: item.title || "Latest News",
        image: item.image || "images/blog/blog-grid/blog-grid1.jpg",
        content: item.content 
          ? item.content.replace(/<[^>]*>/g, "").substring(0, 100) + "..."
          : "Read latest news update",
        date: item.created_at ? formatDate(item.created_at) : formatDate(new Date()),
        slug: item.slug || `news-${item.id}`,
      }));

      setNewsItems(mappedItems);
      setHasData(true); // Set to true only if we have data
      setLoading(false);
    } catch (error) {
      console.error("Error fetching news data:", error);
      setHasData(false);
      setLoading(false);
    }
  };

  // Return null if no data (hides entire section)
  if (!hasData && !loading) {
    return null;
  }

  const carouselOptions = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: {
        items: 1
      },
      768: {
        items: 2
      },
      992: {
        items: 3
      }
    }
  };

  return (
    <div className="blog-section py-5 full-dark mt-3">
      <div className="container">
        <div className="row">
          <div className="offset-md-3 col-md-6">
            <div className="title-wrap text-center">
              <div className="section-title">
                <h2 className="section-title text-uppercase mb-0">
                  Latest <span className="theme-color">News</span>
                </h2>
                <span className="section-border-bottom center"></span>
              </div>
            </div>
          </div>
          
          <div className="col-md-12" data-animation="fadeInUpBig">
            {loading ? (
              <div className="d-flex justify-content-center py-5">
                <Spinner />
              </div>
            ) : (
              <div className="row">
                <OwlCarousel className="owl-carousel blog-main-wrapper blog-style-2" {...carouselOptions}>
                  {newsItems?.map((item) => (
                    <div className="item animated fadeInUp visible" key={item.id}>
                      <div className="blog-inner mb-4">
                        <div className="blog-thumb relative stacked-home-news-wrapper">
                          <img 
                            src={item.image} 
                            className="img-fluid" 
                            alt={item.title} 
                            onError={(e) => {
                              e.target.src = "images/blog/blog-grid/blog-grid1.jpg";
                            }}
                          />
                        </div>
                        <div className="blog-details stacked-news-detail">
                          <div className="top-meta">
                            <ul className="top-meta-list d-flex">
                              <li>
                                <div className="post-date ">
                                  <Link className="side-img-news-date" to={`/news/detail/${item.slug}`}>
                                    <i className="ti-calendar fw-bold"></i> {item.date}
                                  </Link>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="blog-title stacked-home-news-wrapper">
                            <h4 className="margin-bottom-10">
                              <Link style={{fontSize:"20px"}} to={`/news/detail/${item?.slug}`} className="blog-name">
                                {item?.title}
                              </Link>
                            </h4>
                          </div>
                          <div className="post-desc mt-2">
                            <div className="blog-link stacked-home-news-readmore">
                              <Link 
                                to={`/news/detail/${item?.slug}`} 
                                className="link font-w-500"
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </OwlCarousel>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default StackedHomeNews;